<template>
  <div class="login">
    <login-form @forgotPassword="forgotPasswordPopup"></login-form>
    <div class="news-slideshow-wrapper">
      <v-carousel
        height="100%"
        cycle
        :show-arrows="false"
        hide-delimiter-background
      >
        <v-carousel-item :show-arrows="false">
          <v-sheet
            height="100%"
            tile
            :show-arrows="false"
            :style="{
              backgroundImage: 'url(' + require('@/assets/slide1.jpg') + ')',
            }"
          >
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>

<script>
import LoginForm from "../components/Login/LoginForm.vue";
export default {  
  data() {
    return {
      forgotPasswordModal: false,
    };
  },
  components: {
    LoginForm,
  },
  methods: {
    forgotPasswordPopup() {
      alert("todo");
    },
  },
  created(){
    document.title = this.$route.meta.title;
  },
  computed: {
  }
};
</script>

<style scoped>
.login {
  background-color: #f1f6ed;
  display: flex;
  min-height: 100vh;
  align-items: stretch;
}

.news-slideshow-wrapper {
  background-color: rgb(195, 204, 209);
  background-image: radial-gradient(
    circle at top left,
    rgb(195, 204, 209),
    rgb(178, 185, 193)
  );
  overflow: hidden;
  position: relative;
  width: 72%;
}

.v-carousel {
  height: 100%;
}

.v-sheet {
  background-size: cover;
  position: relative;
}

.v-sheet .info-section {
  color: #fff;
  position: absolute;
  bottom: 0;
  font-size: 26px;
  padding: 25px 100px 50px;
  max-width: 75%;
}

.v-sheet .info-section h3 {
  color: #fff !important;
  font-weight: 500;
  font-size: 55px;
  line-height: 75px;
  text-transform: capitalize;
  margin-bottom: 15px;
}

.v-sheet .info-section p {
  font-size: 22px;
  line-height: 26px;
}

.v-sheet .info-section .read-more {
  color: #fff;
  text-decoration: none;
}

.v-sheet .info-section .read-more span {
  text-decoration: underline;
}

.v-icon.v-icon {
  color: #fff;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .login {
    height: 100%;
  }
}
</style>
